// @flow
import * as React from 'react';
import { getItemCardImageUrl, logoUrl } from '../../utils/urls';
import cleanSearchTerms from '../../utils/cleanSearchTerms';
import isEqual from 'react-fast-compare';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';

type Props = $ReadOnly<{|
    baseUrl: string,
    firstItem: any,
    searchTerm: string,
|}>;

const SearchPageHeaderMeta = ({ baseUrl, firstItem, searchTerm }: Props) => {
    const title = `Search “${cleanSearchTerms(searchTerm)}”`;
    const description = `Search terms: ${cleanSearchTerms(searchTerm, true)}`;
    const canonical = `${baseUrl}/search`;

    const { catalogId, imageVersion, itemId, photo, photos, sellerId } = firstItem ? firstItem.item : {};

    let firstPhoto;
    if (photo) {
        firstPhoto = photo;
    } else if (photos && photos.length > 0) {
        firstPhoto = photos[0];
    } else {
        firstPhoto = 0;
    }

    const imageUrl = firstItem ? getItemCardImageUrl(sellerId, catalogId, itemId, firstPhoto, imageVersion) : logoUrl;
    return (
        <PageHeaderMeta canonical={canonical} description={description} imageUrl={imageUrl} title={title}>
            <meta name="robots" content="noindex, nofollow" />
        </PageHeaderMeta>
    );
};

export default React.memo<Props>(SearchPageHeaderMeta, isEqual);
